import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-bootstrap';
import { allCountries } from './Data/AllCountries';
import {
  CardWrapper,
  CarouselContainer,
  CarouselSlide,
  StyledCarousel,
} from './styles/CountryCarousel.styles';
import CountryCard from './CountryCard';
import { getArticlesCount } from '../../content/utils';

const CountryCarousel = () => {
  const [itemsPerSlide, setItemsPerSlide] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setItemsPerSlide(1);
      } else {
        setItemsPerSlide(3);
      }
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Group countries based on itemsPerSlide
  const groupedCountries = allCountries.reduce((acc: any[][], curr, i) => {
    if (i % itemsPerSlide === 0) {
      acc.push([curr]);
    } else {
      acc[acc.length - 1].push(curr);
    }
    return acc;
  }, []);

  return (
    <CarouselContainer>
      <StyledCarousel
        indicators={true}
        nextIcon={<span className="carousel-control-prev-icon" />}
        prevIcon={<span className="carousel-control-next-icon" />}
        interval={null}
      >
        {groupedCountries.map((group, index) => {
          const articlesCount = getArticlesCount();
          return (
            <Carousel.Item key={index}>
              <CarouselSlide>
                {group.map((country) => (
                  <CardWrapper key={country.slug}>
                    <CountryCard
                      {...country}
                      articleCount={
                        articlesCount[
                          country.slug as keyof typeof articlesCount
                        ]
                      }
                      disabled={!country.active}
                    />
                  </CardWrapper>
                ))}
              </CarouselSlide>
            </Carousel.Item>
          );
        })}
      </StyledCarousel>
    </CarouselContainer>
  );
};

export default CountryCarousel;
